import ChangeTypeModal from './change-type-modal';

export default ChangeTypeModal;
